
import { defineComponent } from 'vue'
export default defineComponent({
  emits: [],
  name: 'InvoiceBanner',
  props: {
    imgUrl: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  setup(props, { emit }) {
    return {}
  }
})
